(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["keico-commercial-finance"]) return;
  try {
    
(function(){

const DEFAULT_ROI_INPUTS = Object.freeze({
  projectCost: 25000,
  chargePerBooking: 25,
  capacityBookingsPerWeek: 40,
  occupancyPercent: 35,
  tradingWeeksPerYear: 48,
  variableCostPerBooking: 5,
  monthlyFixedOperatingCosts: 350,
  monthlyFinanceRepayment: 0,
});

const REQUIRED_FIELDS = Object.freeze([
  'projectCost',
  'chargePerBooking',
  'capacityBookingsPerWeek',
  'occupancyPercent',
  'tradingWeeksPerYear',
  'variableCostPerBooking',
  'monthlyFixedOperatingCosts',
]);

class ROIValidationError extends RangeError {
  constructor(errors) {
    super('Please correct the ROI calculator inputs.');
    this.name = 'ROIValidationError';
    this.errors = errors;
  }
}


function validateROIInputs(input) {
  const errors = {};
  if (!input || typeof input !== 'object' || Array.isArray(input)) {
    return { valid: false, errors: { _form: 'Enter the calculator inputs.' }, values: null };
  }
  const values = {};
  for (const key of [...REQUIRED_FIELDS, 'monthlyFinanceRepayment']) {
    const value = key === 'monthlyFinanceRepayment' && input[key] === undefined ? 0 : input[key];
    values[key] = value;
    if (typeof value !== 'number' || !Number.isFinite(value)) {
      errors[key] = 'Enter a finite number.';
    } else if (value < 0) {
      errors[key] = 'Enter zero or a positive number.';
    }
  }
  if (!errors.projectCost && values.projectCost <= 0) {
    errors.projectCost = 'Enter a project cost greater than zero.';
  }
  if (!errors.capacityBookingsPerWeek && values.capacityBookingsPerWeek < 1) {
    errors.capacityBookingsPerWeek = 'Enter a weekly booking capacity of at least 1.';
  }
  if (!errors.occupancyPercent && values.occupancyPercent > 100) {
    errors.occupancyPercent = 'Enter an occupancy between 0 and 100%.';
  }
  if (!errors.tradingWeeksPerYear && (values.tradingWeeksPerYear < 1 || values.tradingWeeksPerYear > 52)) {
    errors.tradingWeeksPerYear = 'Enter between 1 and 52 trading weeks per year.';
  }
  const valid = Object.keys(errors).length === 0;
  return { valid, errors, values: valid ? values : null };
}


function calculateROI(input) {
  const validation = validateROIInputs(input);
  if (!validation.valid) throw new ROIValidationError(validation.errors);
  const v = validation.values;
  const paidBookingsPerYear = v.capacityBookingsPerWeek * v.occupancyPercent / 100 * v.tradingWeeksPerYear;
  const annualRevenue = paidBookingsPerYear * v.chargePerBooking;
  const annualVariableOperatingCosts = paidBookingsPerYear * v.variableCostPerBooking;
  const annualFixedOperatingCosts = v.monthlyFixedOperatingCosts * 12;
  const annualFinanceRepayments = v.monthlyFinanceRepayment * 12;
  const contributionMarginPerBooking = v.chargePerBooking - v.variableCostPerBooking;
  const annualOperatingContribution = annualRevenue - annualVariableOperatingCosts - annualFixedOperatingCosts;
  const annualCashAfterFinance = annualOperatingContribution - annualFinanceRepayments;
  const simpleUnfinancedPaybackYears = annualOperatingContribution > 0 ? v.projectCost / annualOperatingContribution : null;
  const bookingsPerWeekBreakEven = contributionMarginPerBooking > 0
    ? (annualFixedOperatingCosts + annualFinanceRepayments) / (contributionMarginPerBooking * v.tradingWeeksPerYear)
    : null;
  const occupancyBreakEvenPercent = bookingsPerWeekBreakEven === null
    ? null
    : bookingsPerWeekBreakEven / v.capacityBookingsPerWeek * 100;
  const outputs = {
    paidBookingsPerYear,
    annualRevenue,
    annualVariableOperatingCosts,
    annualFixedOperatingCosts,
    annualFinanceRepayments,
    contributionMarginPerBooking,
    annualOperatingContribution,
    annualCashAfterFinance,
    simpleUnfinancedPaybackYears,
    bookingsPerWeekBreakEven,
    occupancyBreakEvenPercent,
  };
  if (Object.values(outputs).some(value => value !== null && !Number.isFinite(value))) {
    throw new ROIValidationError({ _form: 'These amounts are too large to calculate reliably. Enter smaller values.' });
  }
  const warningCodes = [];
  if (contributionMarginPerBooking <= 0) warningCodes.push('NON_POSITIVE_BOOKING_MARGIN');
  if (annualOperatingContribution <= 0) warningCodes.push('NO_POSITIVE_UNFINANCED_PAYBACK');
  if (occupancyBreakEvenPercent !== null && occupancyBreakEvenPercent > 100) warningCodes.push('BREAK_EVEN_EXCEEDS_CAPACITY');
  if (annualCashAfterFinance < 0) warningCodes.push('NEGATIVE_CASH_AFTER_FINANCE');
  return { ...outputs, warningCodes };
}

class KeicoReturnPlanner extends HTMLElement {
 connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.form=this.querySelector('[data-roi-form]');this.fields=Array.from(this.querySelectorAll('[data-roi]'));this.outputs=Array.from(this.querySelectorAll('[data-result]'));this.messages=Object.fromEntries(Array.from(this.querySelectorAll('[data-message]')).map(e=>[e.dataset.message,e.textContent]));this.money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',maximumFractionDigits:0});this.form.addEventListener('submit',e=>e.preventDefault());this.form.addEventListener('input',()=>this.update());this.form.addEventListener('reset',()=>setTimeout(()=>this.update(),0));this.update();}
 update(){const values={};this.fields.forEach(e=>{values[e.dataset.roi]=e.validity.badInput?NaN:(e.dataset.roi==='monthlyFinanceRepayment'&&e.value.trim()===''?undefined:e.valueAsNumber);});const check=validateROIInputs(values);let result=null;try{if(check.valid)result=calculateROI(values);}catch(e){check.valid=false;check.errors=e.errors||{};}this.fields.forEach(e=>e.setAttribute('aria-invalid',String(Boolean(check.errors[e.dataset.roi]))));this.querySelector('[data-roi-error]').hidden=check.valid;const warning=this.querySelector('[data-roi-warning]');if(!check.valid){this.outputs.forEach(e=>e.textContent='—');warning.textContent='';return;}const financed=values.monthlyFinanceRepayment!==undefined;this.outputs.forEach(e=>{const key=e.dataset.result;const value=result[key];if(key==='simpleUnfinancedPaybackYears'){e.textContent=value===null?this.messages.no_payback:value.toFixed(1)+' '+this.messages.years;}else if(key==='bookingsPerWeekBreakEven'){e.textContent=value===null?this.messages.no_break_even:(Math.ceil(value*10)/10).toLocaleString('en-GB',{maximumFractionDigits:1});}else if(key==='annualCashAfterFinance'&&!financed){e.textContent=this.messages.none;}else{e.textContent=this.money.format(value);}});const notes=[];if(result.warningCodes.includes('NON_POSITIVE_BOOKING_MARGIN'))notes.push(this.messages.margin);if(result.warningCodes.includes('NO_POSITIVE_UNFINANCED_PAYBACK'))notes.push(this.messages.no_contribution);if(result.warningCodes.includes('BREAK_EVEN_EXCEEDS_CAPACITY'))notes.push(this.messages.capacity);if(financed&&result.warningCodes.includes('NEGATIVE_CASH_AFTER_FINANCE'))notes.push(this.messages.negative);warning.textContent=notes.join(' ');}
}
if(!customElements.get('keico-return-planner'))customElements.define('keico-return-planner',KeicoReturnPlanner);

(function() { var qs,j,q,s,d=document, gi=d.getElementById,
  ce=d.createElement, gt=d.getElementsByTagName,
  id="calconic_", b="https://cdn.calconic.com/static/js/";
  if(!gi.call(d,id)) { j=ce.call(d,"script"); j.id=id; j.type="text/javascript"; j.async=true;
  j.dataset.calconic=true;
  j.src=b+"calconic.min.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(j,q) }
})();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      // code from Easyflow_team stated
      var recommendedProducts = container.querySelectorAll('.product-recommendations .product-list .product-block'); // product blocks
      if(recommendedProducts && recommendedProducts.length > 0) {
        recommendedProducts.forEach(function (product) {
          var productType = product.dataset.productType;
          if (productType === '23p_po_generated') { // easyflow auto generated type
            product.remove();
          }
        });
        // After filtering, check if there are any remaining products
        var remainingProducts = container.querySelectorAll(".product-recommendations .product-list .product-block");
        // If no products remain, hide the section
        if (remainingProducts && remainingProducts.length === 0) {
          productRecommendationsSection.style.display = "none"; // Hide the section
          return;
        }
      }
      // code from Easyflow_team end
      
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();

  
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
